import { render } from "./VulnNotice.vue?vue&type=template&id=57633031"
import script from "./VulnNotice.vue?vue&type=script&lang=js"
export * from "./VulnNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__